var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 2.23596L6.23086 2.23596C5.12344 2.23596 4.23047 3.12717 4.23047 4.23635L4.23047 11.7281C4.23047 12.8356 5.12168 13.7285 6.23086 13.7285L13.7227 13.7285C14.8301 13.7285 15.723 12.8373 15.723 11.7281L15.723 4.23635C15.723 3.12893 14.8318 2.23596 13.7227 2.23596ZM14.6438 11.6754C14.6438 12.1975 14.2166 12.6492 13.6699 12.6492L6.28359 12.6492C5.76152 12.6492 5.30977 12.2221 5.30977 11.6754L5.30977 4.28909C5.30977 3.76702 5.73691 3.31526 6.28359 3.31526L13.6699 3.31526C14.192 3.31526 14.6438 3.74241 14.6438 4.28909L14.6438 11.6754Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73711 4.90955C2.46992 4.90955 2.2625 5.11697 2.23438 5.35779L2.23438 13.681C2.29766 14.8271 3.23633 15.7254 4.39824 15.7254L12.565 15.7254C12.8305 15.7254 13.0467 15.5092 13.0713 15.2437C13.0713 14.9554 12.8305 14.7375 12.565 14.7375L4.42461 14.7392C3.77422 14.7392 3.24336 14.2084 3.24336 13.558L3.24336 5.4158C3.24336 5.12751 3.00254 4.90955 2.73711 4.90955Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBtn);
export default __webpack_public_path__ + "static/media/copy_btn.d61a966da54d9444cf1f3d325be5900e.svg";
export { ForwardRef as ReactComponent };